import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", " > & {\n    margin-block-start: var(--list-item-margin-block-start);\n  }\n\n  ", " &:last-child {\n    margin-block-end: var(--list-item-margin-block-end);\n  }\n\n  --counter-content: counters(section, '.', ", ") '.';\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", " > & {\n    margin-block-start: var(--list-item-margin-block-start);\n  }\n\n  ", " &:last-child {\n    margin-block-end: var(--list-item-margin-block-end);\n  }\n\n  --counter-content: '", "';\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  color: var(", ");\n\n  list-style: none;\n\n  ", "\n\n  margin-block-end: var(--list-item-margin-block-end);\n  margin-block-start: var(--list-item-margin-block-start);\n\n  &:first-child {\n    margin-block-start: 0;\n  }\n\n  &:last-child {\n    margin-block-end: 0;\n  }\n\n  &::before {\n    position: absolute;\n    left: 0;\n    padding-inline-end: var(--list-item-padding-inline-end);\n\n    color: var(", ");\n\n    transform: translateX(-100%);\n\n    content: var(--counter-content);\n    counter-increment: section;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  --list-padding-inline-start: var(\n    --nested-list-padding-inline-start,\n    calc(", " * 2)\n  );\n\n  --list-item-padding-inline-end: ", ";\n\n  --list-item-margin-block-start: var(\n    --nested-item-margin-block-start,\n    ", "\n  );\n\n  --list-item-margin-block-end: var(\n    --nested-item-margin-block-end,\n    ", "\n  );\n\n  margin: 0;\n\n  padding-inline-start: var(--list-padding-inline-start);\n\n  ", "\n\n  ", "\n\n  counter-reset: section;\n\n  .", " {\n    --nested-list-padding-inline-start: ", ";\n    --nested-item-margin-block-start: ", ";\n    --nested-item-margin-block-end: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
import { injectTypography } from '../../utils/injectTypography';
import { cssPostfix } from '../../utils/cssPostfix';
export var listClassName = "list-".concat(cssPostfix);

var dynamicSpacingLarge = function dynamicSpacingLarge(props) {
  switch (props.textVariant) {
    case 'copy1':
      return "var(".concat(props.theme.responsive.spacing.m, ")");

    case 'copy2':
      return "var(".concat(props.theme.responsive.spacing.s, ")");

    case 'copy3':
      return "var(".concat(props.theme.responsive.spacing.s, ")");

    default:
      return "var(".concat(props.theme.responsive.spacing.m, ")");
  }
};

var dynamicSpacingMedium = function dynamicSpacingMedium(props) {
  switch (props.textVariant) {
    case 'copy1':
      return "var(".concat(props.theme.responsive.spacing.s, ")");

    case 'copy2':
      return "var(".concat(props.theme.responsive.spacing.xs, ")");

    case 'copy3':
      return "var(".concat(props.theme.responsive.spacing.xs, ")");

    default:
      return "var(".concat(props.theme.responsive.spacing.s, ")");
  }
};

var BaseListStyles = css(_templateObject(), dynamicSpacingLarge, dynamicSpacingMedium, dynamicSpacingLarge, dynamicSpacingLarge, injectSpacing('margin'), function (props) {
  return injectTypography(props, props.textVariant);
}, listClassName, dynamicSpacingLarge, dynamicSpacingMedium, dynamicSpacingMedium);
var BaseListItemStyles = css(_templateObject2(), function (props) {
  return props.theme.colors.ui.secondary;
}, injectOSXFontSmoothing(true), function (props) {
  return props.theme.colors.ui.tertiary;
});
export var StyledListItem = styled.li(_templateObject3(), BaseListItemStyles);
export var StyledListUnordered = styled.ul(_templateObject4(), BaseListStyles, StyledListItem, StyledListItem, function (props) {
  return props.variant === 'bullet' ? '›' : '';
});
export var StyledListOrdered = styled.ol(_templateObject5(), BaseListStyles, StyledListItem, StyledListItem, function (props) {
  return props.variant;
});